/* Cashmere Blanc — sticky "Add to bag" bar for small screens (sections/cb-product-sticky-bar.liquid).
   It mirrors Flow's own add-to-cart button: the bar appears once that button has scrolled above the viewport and
   forwards clicks to it, so variant selection, cart behaviour and error messages all stay Flow's. */

class CbStickyAtc extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-cb-sticky-button]');
    this.meta = this.querySelector('[data-cb-sticky-meta]');
    this.label = this.button.textContent.trim();
    this.form = document.querySelector('product-information');
    this.small = window.matchMedia('(max-width: 989px)');

    if (!this.form) return;

    this.button.addEventListener('click', () => {
      if (this.target && !this.target.disabled) this.target.click();
    });

    // Measured on scroll (one read per frame) rather than with an IntersectionObserver,
    // which never fires when a fast scroll jumps straight past the button.
    this.onScroll = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.measure();
      });
    };
    this.onViewportChange = () => this.measure();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.small.addEventListener('change', this.onViewportChange);

    // Flow re-renders parts of the product form when the variant changes.
    this.mutations = new MutationObserver(() => this.bind());
    this.mutations.observe(this.form, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    this.form.addEventListener('change', () => this.sync());

    this.bind();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    this.small.removeEventListener('change', this.onViewportChange);
    this.mutations?.disconnect();
    cancelAnimationFrame(this.frame);
    document.body.classList.remove('cb-has-sticky-atc');
  }

  bind() {
    this.target = this.form.querySelector('button[name="add"]');
    this.sync();
    this.measure();
  }

  sync() {
    if (!this.target) return;

    const disabled = this.target.disabled;
    const status = this.target.querySelector('[data-add-to-cart-text]')?.textContent.trim();
    this.button.disabled = disabled;
    this.button.textContent = disabled && status ? status : this.label;

    const options = [...this.form.querySelectorAll('input[data-product-variant]:checked, select[data-product-variant]')]
      .map(field => field.value)
      .filter(Boolean);
    const price = this.form.querySelector('[data-price-text]')?.textContent.trim();
    this.meta.textContent = [...options, price].filter(Boolean).join(' · ');
  }

  measure() {
    const passed = Boolean(this.target) && this.target.getBoundingClientRect().bottom < 0;
    const show = passed && this.small.matches;
    if (show !== this.hidden) return;
    this.hidden = !show;
    document.body.classList.toggle('cb-has-sticky-atc', show);
  }
}

if (!customElements.get('cb-sticky-atc')) customElements.define('cb-sticky-atc', CbStickyAtc);
